export function normalizeBrazilPhone(input = '') {
  const digits = String(input || '')
    .replace(/\D+/g, '')
    .slice(0, 11);
  return digits;
}

export default normalizeBrazilPhone;
